/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticleSlider from 'base/components/standalone/ArticleSlider';

export const DynamicStandaloneArticleSlider = StandaloneArticleSlider;
export type DynamicStandaloneArticleSliderProps = PropsFromComponent<typeof StandaloneArticleSlider>;

export const DynamicStandaloneArticleSliderWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticleSlider => {
    return function DynamicStandaloneArticleSlider(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleSlider');
        return <StandaloneArticleSlider {...mergeProps({ options: { theme } }, props)} />;
    }
}